<template>
  <div class="popup_overlay confirm-box-overlay relative px-4">
       <div style="width: 500px;" class="custom_dialog rounded-xl h-min p-4">
          <div  class="mb-4 font-bold">
            <p class="heading-3 text-text1 whitespace-pre-line">{{title}}</p>
          </div>
          <div  class="mb-5">
            <p class="heading-6 text-text1 mb-4 whitespace-pre-line break-words">{{message}}</p>
            <div v-if="yesConfir">
              <TextField
              :inputId="'yesinputText'"
              :showcharLimit="false"
              :inputext="yesinputText"
              :lableText="`${inputLable}`"
              :autoFocus="true"
              @inputChangeAction="(data) => yesinputText = data"  />
            </div>
          </div>
          <div v-if="warning" class="flex gap-2 justify-end">
            <Button :btnSize="'medium'" :textColor="'white'" :btnColor="'primary'" :btnText="'OK'" @buttonAction="cancel"/>
          </div>
          <div v-else class="flex gap-2 justify-end">
            <Button :btnSize="'medium'" :textColor="`${cancelTextColor ? cancelTextColor : 'text1'}`" :btnColor="`${lbtnColor ? lbtnColor : 'gray1' }`" :btnText="`${cancelbtnText ? cancelbtnText : 'No' }`" @buttonAction="cancel"/>
            <Button :disabled="yesinputText.toLowerCase() !== 'yes'" :btnSize="'medium'" :textColor="`${confirmTextColor ? confirmTextColor : 'white'}`" :btnColor="`${rbtnColor ? rbtnColor : 'error' }`" :btnText="`${confirmBtnText ? confirmBtnText : 'Yes' }`" @buttonAction="sure"/>
          </div>
    </div>
  </div>
</template>
<script>
import Button from '@/View/components/globalButton.vue'
import TextField from '@/View/components/textfield.vue'
export default {
  props: ['title', 'message', 'warning', 'yesConfir', 'inputLable', 'cancelbtnText', 'confirmBtnText', "lbtnColor", "rbtnColor", "cancelTextColor","confirmTextColor"],
  components: {
    Button,
    TextField,
    },
  data () {
    return {
      yesinputText: 'yes'
    }
  },
  computed: {
  },
  mounted () {
    if (this.yesConfir) {
      this.yesinputText = ''
    }
    document.body.style = 'overflow: hidden;'
  },
  methods: {
    cancel () {
      console.log('ConfirmBox cancel clicked');
      // this.$root.$emit('confirmBoxHandler', false)
      this.$emit('confirmBoxHandler', false)
      console.log('ConfirmBox after cancel clicked');
      // document.body.style = 'overflow: visible;'
    },
    sure () {
      console.log('ConfirmBox sure clicked');
    //  this.$root.$emit('confirmBoxHandler', true)
     this.$emit('confirmBoxHandler', true)
     console.log('ConfirmBox after sure clicked');
    //  document.body.style = 'overflow: visible;'
    }
  }
}
</script>

<style scoped>
.confirm-box-overlay {
  z-index: 2000 !important; /* Ensure it’s above other modals */
}
</style>
